window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.bwc-header').length) {
    import('./_sticky-header.js')
      .then((module) => {
        if (typeof module.Init === 'function') {
          module.Init();
        }
      })
      .catch((error) => {
        console.error('Fehler beim Laden des Sticky-Header-Moduls:', error);
      });
  }
});

export default {};
